__gh__webApp.articlePage 			= __gh__webApp.articlePage || {};
__gh__webApp.articleExtLoginPage 	= __gh__webApp.articleExtLoginPage || {};

var __gh__articlePage_fullArticleCount 	= 0;
	__gh__articlePage_articleLoaded		= false;



/*
|--------------------------------------------------------------------------
| Article: Init
|--------------------------------------------------------------------------
*/

/**
 * Contains callbacks for loading an article that can be used on bucket laydown and when fetching a new article
 */
__gh__webApp.articlePage.init = function(){

    var utilities 	= __gh__webApp.utilities,
		ads			= __gh__webApp.ads;
		
		utilities["3rdPartyIframes"].init();

	$(document).ready(function () {
		var articlePage 		= __gh__webApp.articlePage,
			articleExtLoginPage	= __gh__webApp.articleExtLoginPage,
			currentPage			= __gh__webApp.currentPage;
			utilities			= __gh__webApp.utilities;

			articlePage.fetchArticle.init();

			articlePage.bindEvents();
			articlePage.relatedLinksHandler.init();
			utilities.fetch.bucket.init();
			
		if(currentPage.isArticleExtLogin()){
			articleExtLoginPage.init();
		}

	});
};









/*
|--------------------------------------------------------------------------
| Article: Bind Events
|--------------------------------------------------------------------------
*/

/**
 * Contains Bind Events for article page
 */
__gh__webApp.articlePage.bindEvents = function(){


	/**
	 * History API Popstate Event Listener
	 * Will only fire for a "popstate" event - https://github.com/browserstate/history.js/issues/47#issuecomment-25750285
	 */
	 History.Adapter.bind(window,'statechange',function(){
		 
		/*	SCROLL DOESN'T WORK SMOOTHLY - THINK I NEED TO DISABLE AND ENABLE WAYPOINT DURING SCROLL

			var commonJS		= __gh__webApp.common,
			currentIndex 	= History.getCurrentIndex(),
			state 			= History.getState(),
		 	internal 		= (state.data._index == (currentIndex - 1)),
			data  			= state.data,
			articlePage		= data.articleDOM + " .scroll-page[data-page="+data.page+"]";
		if (!internal && !commonJS.isObjectEmpty(data)) {
			alert("articleDOM:"+articlePage);
			$('html, body').animate({
			    "scrollTop": $(articlePage).offset().top
			},"fast");
		}*/
	});

};





/*
|--------------------------------------------------------------------------
| Article: Article Ads
|--------------------------------------------------------------------------
*/

/**
 * Contains callbacks for loading an article that can be used on bucket laydown and when fetching a new article
 */
__gh__webApp.articlePage.articleAds = {


	/**
	 * Inject ads
	 * @param {object} options
	 * @param {object} options.articleObject - Article object
	 * @param {string} options.articleDOM - Article container DOM
	 */
	"injectAds": function(articleDOM,articleObject){
		if (__gh__webApp.ads.dfp.isDisabled()) {return;}
		
		var $allGraphs 			= $(articleDOM+' .article-body p:not(.article-summary,table p),'+articleDOM+' .article-body div.related,'+articleDOM+' .article-body .article-block'),
			$lessGraphs 		= $(articleDOM+" .article-body"),
			firstAdGraph		= 2,
			$firstAdGraph		= $allGraphs[firstAdGraph],
			adOffset			= 5,
			$startingGraph		= $allGraphs[(adOffset-1)],
			totalGraphs			= $allGraphs.length,
			adFrequency			= 7,
			totalAds			= Math.floor((totalGraphs-adOffset)/adFrequency);
		
			
		//debug.log("articleDOM= "+articleDOM)
		//debug.log("articleObject= "+articleObject)
		//debug.log("$lessGraphs= "+$lessGraphs)
		//Inject first ad if less than firstAdGraph
		if(firstAdGraph > totalGraphs){
			var adObj = {},
				html  = __gh__webApp.utilities.fetch.handlebarsView.get({
					"view":"buckets/partials/ads/_medRecBaseArticle","data":{keywords:articleObject.keywords}
				});
			__gh__webApp.device.isPhone() ? $(html).appendTo($lessGraphs) : $($lessGraphs).prepend(html)
		}
		
		//Inject first ad
		if($firstAdGraph){
			var adObj = {},
				html  = __gh__webApp.utilities.fetch.handlebarsView.get({
					"view":"buckets/partials/ads/_medRecBaseArticle","data":{keywords:articleObject.keywords}
				});
			$allGraphs.eq(firstAdGraph).before(html);
		}


		if(!$startingGraph && (totalGraphs < adFrequency)){return;}

		for(var i=0;i<totalAds;i++){
			var start 			= ((((i+1) * adFrequency) + adOffset) - adFrequency),
				end				= (start-1) + adFrequency,
				injectionPoint	= end - (adFrequency/2),
				relCheck		= false;

			for(var ii=start;ii<end;ii++){
				var graph = ii-1;
				if(relCheck){continue;}
				if($allGraphs.eq(graph).hasClass('related')){relCheck = true;}
				if((ii+1)==end){
					var adObj = {},
						html  = __gh__webApp.utilities.fetch.handlebarsView.get({
							"view":"buckets/partials/ads/_medRecLazyArticle","data":{keywords:articleObject.keywords}
						});
					$allGraphs.eq(graph).before(html);
				}
			}
		}
	}
};

















/*
|--------------------------------------------------------------------------
| Article: Load Article
|--------------------------------------------------------------------------
*/

/**
 * Contains callbacks for loading an article that can be used on bucket laydown and when fetching a new article
 */
__gh__webApp.articlePage.loadArticle = {

	/**
	 * Callbacks that are run when an article is loaded.  Used for the bucket laydown and read more links that are clicked.
	 * @param {object} options
	 * @param {object} options.articleObject - Article object
	 * @param {string} options.articleDOM - Article container DOM
	 */
	"callbacks": function(options){
		var articleObject 		= (options.articleObject) 	? options.articleObject : {},
			articleDOM			= (options.articleDOM) 		? options.articleDOM 	: null,
			trackArticle		= __gh__webApp.utilities.tracker.trackArticle,
			utilities 			= __gh__webApp.utilities,
			ads					= __gh__webApp.ads,
			articlePage			= __gh__webApp.articlePage,
			comments			= __gh__webApp.comments,
			analytics			= __gh__webApp.analytics,
			social				= __gh__webApp.social,
			consumerMarketing 	= __gh__webApp.consumerMarketing,
			video				= __gh__webApp.video;
	
		__gh__coreData.globalVariables.article.loadArticle.relatedContentCount = 0;
		
		consumerMarketing.contextly.loadArticleWidgets(articleDOM,articleObject);
		
		social.twitter.loadAllWidgets(articleDOM);
		
		
		$(articleDOM).attr("data-article-object", '{"guid": "'+articleObject.guid+'"}');
		
		
		articlePage.relatedContent.injectRelatedContent(articleDOM,articleObject);
		
		
		articlePage.articleAds.injectAds(articleDOM,articleObject);
	
		if(__gh__adsLoaded){
			var k = 'article keywords';
			ads.dfp.buildKruxCatlist(k,articleObject.keywords);
			analytics.krux.refreshData();
		}
		ads.init();
	
	
		// disable sticky meta on artv1 for now while story strip is being tested
		// articlePage.stickyMeta.init(articleDOM);
	
		// add third party callbacks here
		comments.viafoura.reset();
		
		trackArticle.allArticlesOnLoad({"articleObject":articleObject});
	
		articlePage.articleURLHandler.addScrollListeners(articleDOM,articleObject);
	
		//For Viafoura social hub widget. Call viafoura ideacloud js if .ideacloud div is present.
		if ($(".ideacloud")[0]){
			__gh__webApp.common.loadScript({"src":"http://portal.ideacloud.me/embed/embed.js"});
		}
		
		__gh__webApp.ads.teads.loadInRead();
		
		//REMOVED PAGINATION FOR NOW
		//articlePage.pagination(articleDOM,articleObject);
		
		articlePage.downloader.prepFile(articleDOM, articleObject);

		smartquotes();
			
	}
};









/*
|--------------------------------------------------------------------------
| Article: Consumer Survey 
|--------------------------------------------------------------------------
*/

__gh__webApp.articlePage.consumerSurvey = {
	
	"isSurveyLoaded": function(){
		var thisObject	= __gh__webApp.articlePage.consumerSurvey;
		if (thisObject.isDisabled()) { return; }
			return $(".t402-elided").length > 0;
	},

	/**
	 * Main survey code was added server side just below the body tag per google's recommendation
	 * This function calls their code
	 */
	"showSurvey": function(){
		var thisObject	= __gh__webApp.articlePage.consumerSurvey,
			articleURL 	= window.location.href,
			contentID 	= 'everything';
		if (thisObject.isDisabled()) { return; }
		
		TriggerPrompt(articleURL,contentID);
	},
	
	"showSurveyCallback": function(){
		var thisObject		= __gh__webApp.articlePage.consumerSurvey,
			consumerSurvey 	= __gh__webApp.articlePage.consumerSurvey;
		if (thisObject.isDisabled()) { return; }
		if (consumerSurvey.isSurveyLoaded()){
			__gh__webApp.articlePage.fetchArticle.disableFetch();
		}
	},

	"isDisabled": function(){
		var surveyID 	= __gh__coreData["3rdPartyData"].analytics.google.consumerSurvey.id,
			isDisabled	= __gh__coreData["3rdPartyData"].analytics.google.consumerSurvey.isDisabled;
		try{
		if(__gh__webApp.paywall.isUserLoggedIn() || !surveyID || isDisabled) { return true; } else { return false; }
		}
		catch(e){
			debug.log("__gh__coreData[3rdPartyData].ads.dfp.consumerSurvey fail. "+e)
		}
	}

};






/*
|--------------------------------------------------------------------------
| Article: Related Content
|--------------------------------------------------------------------------
*/

__gh__webApp.articlePage.relatedContent = {
	"defaults":{
		"frequency": 3,
	},

	"callbacks": function(articleDOM,articleObject){
		var utilities 	= __gh__webApp.utilities,
			articlePage = __gh__webApp.articlePage,
			video		= __gh__webApp.video,
			ads			= __gh__webApp.ads,
			analytics	= __gh__webApp.analytics;
			
	
		utilities.googleMap.loadAllMaps();
		utilities.slider.loadAllSliders();
		utilities.showMoreLink.loadAllShowMoreLinks();
		video.tout.injectMidArticlePlayer(articleDOM);
		ads.teads.injectInRead(articleDOM);
		utilities.lazyImages.loadAllImages();
	},

	/**
	 * Draws the related content widgets within the article body
	 * @param {object} options
	 * @param {object} options.relatedContent={}
	 */
    "injectRelatedContent": function(articleDOM,articleObject) {

	    var thisObject					= __gh__webApp.articlePage.relatedContent,
	    	relatedContentObject		= articleObject.relatedContent,
	    	manualPlacement				= relatedContentObject.manualPlacement,
			commonJS 					= __gh__webApp.common,
			toutID						= __gh__webApp.video.tout.getToutId(),
			isToutDisabled				= __gh__webApp.video.tout.isDisabled(),
			isAdBlockOn					= __gh__coreData.globalVariables.ads.isAdBlockOn,
			isMobile					= __gh__webApp.device.isMobile(),
			cookiesEnabled				= commonJS.cookiesEnabled(),
			isMobileWithCookiesEnabled 	= (isMobile && cookiesEnabled),
			options						= {
				"offsetPlacement"	: false,
				"articleObject"		: articleObject,
				"articleDOM"		: articleDOM
			};
	
	
		// Check for Tout
		if(!isToutDisabled || (!window.TOUT && toutID && !isAdBlockOn && (!isMobile || isMobileWithCookiesEnabled))){
			
			window.TOUT = {
				"propertyUid": toutID,
				"topArticleLoaded": function(e){
					if(e.matchExists){
						if(!manualPlacement){
							options.offsetPlacement = true;
						}
					}
					thisObject.insertRelatedContent(options);
				}
			};
			commonJS.loadScript({"src":"http://platform.tout.com/sdk.js"});
			return;
			
		}
	
		thisObject.insertRelatedContent(options);
	
	},
	
	
	/**
	 * Inserts related content into the page
	 */
	"insertRelatedContent": function(options){
		var thisObject 				= __gh__webApp.articlePage.relatedContent,
			commonJS				= __gh__webApp.common,
			articleDOM 				= ("articleDOM" in options) ? options.articleDOM : null,
	    	articleObject			= ("articleObject" in options) ? options.articleObject : {},
	    	relatedContentObject	= ("relatedContent" in articleObject) ? articleObject.relatedContent : {},
	    	offsetPlacement			= (options.offsetPlacement)	? options.offsetPlacement : false,
	    	relatedContent			= relatedContentObject.items,
	    	relatedContentDefaults	= relatedContentObject.defaults,
	    	placementObject			= relatedContentObject.placement,
			relatedLinks			= {
				"view": "buckets/article/relatedContent/links",
				"type": "links",
				"items": []
			},
			relatedLinksDefaults	= (commonJS.isObjectPropertySet(relatedContentDefaults,"links.items.main")) ? relatedContentDefaults.links : null,
			relatedContentIndex		= 0,
			commonJS 				= __gh__webApp.common,
			mainImage				= null;
	
		if (relatedContent.length === 0 && !relatedLinksDefaults) {return;}
	
		relatedContent.push(relatedLinks);
		relatedContent = this.sortRelatedContentByPlacement(relatedContent);
	
		//Sort and cleanup placements to remove nodes that don't exist
		relatedContentObject.placement 		= this.sortPlacementObject(placementObject,relatedContent);
		if(offsetPlacement){
			relatedContentObject.placement 	= this.offsetPlacement(placementObject);
		}
	
	
		for (var i=0; i < relatedContent.length; i++) {
			var defaults 			= __gh__webApp.articlePage.relatedContent.defaults,
				type 				= relatedContent[i].type,
				items				= relatedContent[i].items;
	
	
			if(type=="links"){continue;}
	
			//Add main image as the first related image
			if (type =="mainImage"){
				mainImage = items;
				continue;
			}
			if (type =="images"){
				if(mainImage && !commonJS.isArrayEmpty(mainImage)){
					relatedContent[i].items.unshift(mainImage[0]);
				}
				if(commonJS.isArrayEmpty(items)){
					continue;
				}
			}
	
			// If map doesn't have items, skip it.
			if (type=="map" && commonJS.isArrayEmpty(items)){
				continue;
			}
	
			//Build related links
			if (commonJS.isArrayEmpty(items)) {
				relatedLinks.items.push(relatedContent[i]);
				continue;
			}
			
			
			this.addRelatedContentToPage({
				"relatedContentItem"	: relatedContent[i],
				"relatedContentObject"	: relatedContentObject,
				"relatedContentIndex"	: relatedContentIndex,
				"articleDOM"			: articleDOM,
				"articleObject"			: articleObject
			});
	
	
			relatedContentIndex++;
		}
	
		// No related links, use defaults
		if (relatedLinks.items.length === 0 && relatedLinksDefaults) {
			relatedLinks = relatedLinksDefaults;
		}
		this.addRelatedContentToPage({
			"relatedContentItem"	: relatedLinks,
			"relatedContentObject"	: relatedContentObject,
			"relatedContentIndex"	: relatedContentIndex,
			"articleDOM"			: articleDOM,
			"articleObject"			: articleObject
		});
	
		thisObject.callbacks(articleDOM,articleObject);
	
	},


	/**
	 * Adds related content to the page
	 * Defaults to inserting at every 3 paragraphs unless the editor set manualPlacement to true
	 */
	"addRelatedContentToPage": function(options){
		var relatedContentItem 		= ("relatedContentItem" in options) ? options.relatedContentItem : {},
			relatedContentObject 	= ("relatedContentObject" in options) ? options.relatedContentObject : {},
			relatedContentIndex 	= ("relatedContentIndex" in options) ? options.relatedContentIndex : null,
			articleDOM 				= ("articleDOM" in options) ? options.articleDOM : null,
			articleObject			= ("articleObject" in options) ? options.articleObject : {};
	
		
		if (relatedContentItem.items.length === 0) {return;}
		
	
		__gh__coreData.globalVariables.article.loadArticle.relatedContentCount++;
		
		
		//Add article nodes to pass to view...parse.ly gave an error if I tried to pass the whole articleObject
		relatedContentItem.article = {
			"dom": articleDOM,
			"title": articleObject.title,
			"link": articleObject.link
		};
	
		var defaults 			= __gh__webApp.articlePage.relatedContent.defaults,
			fetchHandlebarsView = __gh__webApp.utilities.fetch.handlebarsView,
			manualPlacement		= relatedContentObject.manualPlacement,
			placementObject		= relatedContentObject.placement,
			placement 			= placementObject[relatedContentItem.type],
			paragraphCount 		= (manualPlacement) ? placement : (relatedContentIndex + 1) * defaults.frequency,
			$article 			= $(articleDOM),
			$articleBody 		= $article.find(".article-body"),
			type				= relatedContentItem.type,
			view				= (placement==0 && "featuredView" in relatedContentItem) ? relatedContentItem.featuredView : relatedContentItem.view,
			html 				= fetchHandlebarsView.get({"view":view,"data":relatedContentItem}),
			paragraphIndex		= calculateParagraphIndex(manualPlacement,placement);
	
	
		function calculateParagraphIndex(manualPlacement,placement){
			var offset 		= 5,
				frequency	= 3
	
			if (!manualPlacement){
				return (placement == 1) ? offset : ((placement-1) * frequency) + offset;
			}
			return placement;
		}
	
	
		if(type=="mug"){
			$articleBody.find("p:not(.article-summary)").eq(0).before(html);
			return;
		}
	
	
		if (placement==0){
			if($article.hasClass('article-v2') === true) {
				$article.find(".article-v2-right").prepend(html);
			} else {
				$article.find("h1.headline").after(html);
			}
			return;
		}
	
	
		if($articleBody.find("p").not(".related p").eq(paragraphIndex).length == 0){
			$articleBody.append(html);
		} else {
			$articleBody.find("p").not(".related p").eq(paragraphIndex).before(html);
		}
	
	},


	/**
	 * If there is a tout annatator video for the top of the article and manualPlacement is false
	 * add one to placements
	 */
    "offsetPlacement" : function (placementObject) {
	   for (var key in placementObject){
		  if (key == "mugs"){continue;}
		  placementObject[key]++;
	   }
	   return placementObject;
    },


	/**
	 * Sorts the article objects by placement
	 * @param {array} obj - related content array of objects
	 */
	"sortRelatedContentByPlacement" : function(obj){
		var sortedObj = $.map(obj, function (o) {return [o];}).sort(function (a,b) {return a.placement - b.placement;});
		return sortedObj;
	},


	/**
	 * Sorts a placement object and removes related content nodes that do not exist
	 * https://jsfiddle.net/9puvdznz/1/
	 */
	 "sortPlacementObject": function (placementObj,relatedContent) {

	    //Remove any related content nodes that do not exist in the placement object
		function cleanUpPlacements(placementObj,relatedContent){
	    	var newPlacementObj = {};
	    	for (prop in placementObj) {
				var found = relatedContent.some(function (item) {
	              return item.type === prop;
	            });
	            if (found) {
	               newPlacementObj[prop] = placementObj[prop];
	            }
	      }
	      return newPlacementObj;
	    }


	    //Convert the placements object to an array so that it can be sorted
	  	function convertToArray(obj){
	     var arr = [],
	     		 prop;
	      for (prop in obj) {
	          if (obj.hasOwnProperty(prop)) {
	              arr.push({
	                  'key': prop,
	                  'value': obj[prop]
	              });
	          }
	      }
	      return arr;
	    }


	    //Convert it back to an object to an array and update values
	    function convertToObject(arr){
	    	var newObj 	= {};
	    	for (var i=0; i < arr.length; i++) {
	          newObj[arr[i].key] = i;
	      }
	      return newObj;
	    }


	    var placementObj 	= cleanUpPlacements(placementObj,relatedContent),
	    	arr 			= convertToArray(placementObj);
	       	arr.sort(function(a, b) {
	            return a.value - b.value;
	        });

	    return convertToObject(arr);
	}



};



/*
|--------------------------------------------------------------------------
| Article: Fetch Article
|--------------------------------------------------------------------------
*/

__gh__webApp.articlePage.fetchArticle = {


	/**
	 * Initialize
	 */
	"init": function() {
		this.bindEvents();
	},


	/**
	 * Get a full article using url, view and dom
	 * @namespace
	 * @param {object} options
	 * @param {string} options.url - json data url to fetch
	 * @param {string} options.dom - html dom to insert data
	 * @param {string} options.view - name of handlebars view
	 * @example
	 *	<a href="#"
	 *		data-gh-fetch-article-view="buckets/article/partials/_article"
	 *		data-gh-fetch-article-dom="#gh-fetch-view-{{id}}"
	 *		data-gh-fetch-article-url="{{feedURL}}"
	 *	>{{title}}</a>
	 */
	 "get": function(options){
		var commonJS				= __gh__webApp.common,
			url 					= (options.url) 			? options.url 				: null,
			dom 					= (options.dom) 			? options.dom 				: null,
			view 					= (options.view) 			? options.view 				: null;
	
		//Check variables
		if(!url){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.articlePage.fetchArticle.get",message:"Missing url."});
			return;
		}
		if(!dom){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.articlePage.fetchArticle.get",message:"Missing dom."});
			return;
		}
		if(!view){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.articlePage.fetchArticle.get",message:"Missing view."});
			return;
		}
	
	
		//Get JSON
			url 				= commonJS.noCacheURL(url);
		var data 				= {"items": __gh__webApp.utilities.fetch.json.get({"url":url})};
		
		
		if(!data.items.main){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.articlePage.fetchArticle.get",message:"Getting the data failed."});
			return;
		}
	
		
		//Prep Items
		data.items.main 	= __gh__webApp.views.article.prepItemData(data.items.main);
		
		
		//Get View
		var html = __gh__webApp.utilities.fetch.handlebarsView.get({
			"view": view,
			"data": data
		});
		if(!html){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.articlePage.fetchArticle.get",message:"Getting the view failed."});
			return;
		}
	
	
		$(dom).html(html);
	
	
		return data.items.main[0];
	
	},

	/**
	 * Show the full article
	 */
	"showFullArticle": function(readMoreDOM){
		var commonJS			= __gh__webApp.common,
			articlePage			= __gh__webApp.articlePage,
			prependView 		= __gh__webApp.utilities.fetch.handlebarsView.prepend,
			fetchArticle 		= articlePage.fetchArticle,
			trackArticle		= __gh__webApp.utilities.tracker.trackArticle,
			$article			= $(readMoreDOM).parents("article"),
			articleDOM			=  $(readMoreDOM).data("gh-fetch-article-dom"),
			articleObject;
	
		$(articleDOM).parent().css("position","relative");
	
		//Inject overlay
		prependView({
			"dom": $(articleDOM).parent(),
			"view": "buckets/articleHalfCard/partials/_loadingOverlay"
		})
	
		//Scroll to top of article
		$('html, body').animate({
	    	scrollTop: $article.offset().top
		}, 500).promise().then(function() {
	
			// Load Article
			articleObject = fetchArticle.get({
				"dom"			: articleDOM,
				"url"			: $(readMoreDOM).data("gh-fetch-article-url"),
				"view"			: $(readMoreDOM).data("gh-fetch-article-view")
			});
	
		}).promise().then(function(){
	    	var isExtLogin 	= articleObject.isExtLogin,
	    		isMetered	= articleObject.metered;
			
			//MPP   	
	    	if(__gh__coreData.siteData.providers.paywall != "mpp"){return;}
			
			// Send to new page
	    	if(isExtLogin){
		    	window.location = articleObject.link;
	    	}
	    	
	    	//Update Session Bar
	    	if(!isExtLogin && isMetered){
		    	__gh__webApp.paywall.sessionBar.incrementTotalPremiumClicks();
	    	}
	    	
	    }).promise().then(function(){
	    	
	
			__gh__articlePage_fullArticleCount++;
			$article.attr("data-gh-full-article-counter",__gh__articlePage_fullArticleCount);
	
	    	__gh__webApp.articlePage.loadArticle.callbacks({"articleObject":articleObject,"articleDOM":articleDOM});
	
	    	__gh__webApp.social.addToAny.reloadShareButtons();
	
	    	__gh__webApp.paywall.meterReadMoreArticle(articleDOM,articleObject);
	    	
			History.replaceState(null, articleObject.title, articleObject.link);
			
			trackArticle.readMoreFullArticle({"articleObject":articleObject});
	    	
		}).promise().then(function() {
	
			// Hide Read more
		    $(readMoreDOM).closest(".halfCard").hide();
		    $article.removeClass("collapsed");
	
	    }).promise().done(function() {
		    
	    	$article.find(".loading-article-overlay").fadeOut();
	    	__gh__webApp.articlePage.articleURLHandler.refreshScrollListeners();

	    	//__gh__webApp.paywall.refreshArticleExperience(articleObject);
	    });
	
	},


	/**
	 * Remove the full articles that are displayed and show the half card instead
	 */
	"removeFullArticles": function(){
		var totalArtsShown 		= __gh__articlePage_fullArticleCount,
			maxArtsToShow		= 1;

		if(totalArtsShown === maxArtsToShow){
			$("[data-gh-full-article-counter]").each(function(){
				var $this 					= $(this),
					$thisCounter 			= $this.attr('data-gh-full-article-counter'),
					$thisFullArtContainer 	= $this.find('.fullArticle'),
					$thisHalfCard			= $this.find('.halfCard');

				if($thisCounter==1){
					$thisHalfCard.show();
					$thisFullArtContainer.html('');
					$this.removeAttr('data-gh-full-article-counter');
					__gh__articlePage_fullArticleCount--;
					$this.addClass("collapsed");
				}
			});

			$("[data-gh-full-article-counter]").each(function(){
				var $this 			= $(this),
					$thisCounter 	= $this.attr('data-gh-full-article-counter');
					$thisCounter--;
				$(this).attr('data-gh-full-article-counter',$thisCounter);
			});
		}

	},


	/**
	 * Bind the UI events
	 */
	"bindEvents": function() {
		var fetchArticle = __gh__webApp.articlePage.fetchArticle;

	    $(document).on("click", "a[data-gh-fetch-article-url]", function(event){
		    var trackReadMoreClick = __gh__webApp.utilities.tracker.trackArticle.readMoreClick;
		    event.preventDefault();
			//fetchArticle.removeFullArticles();
			fetchArticle.showFullArticle(this);
			trackReadMoreClick({
				"label": "Read More",
				"category": "Read More",
				"nonInteraction": true
			});
			//alert("track");
		});
  	},
  	
  	
  	/**
	 * Disable fetch event
	 */
  	"disableFetch": function(){
		$("a[data-gh-fetch-article-url]").removeAttr("data-gh-fetch-article-url");
	}
};









/*
|--------------------------------------------------------------------------
| Article: Pagination
|--------------------------------------------------------------------------
*/

/**
 * Handles Pagination for the article
 *
 */
__gh__webApp.articlePage.pagination = function(articleDOM,articleObject){
	var commonJS		= __gh__webApp.common,
		articleID		= articleDOM.replace("#",""),
		$article		= $(articleDOM),
		isMobile		= __gh__webApp.device.isMobile(),
		scrollPageClass = "scroll-page",
		scrollPageDOM	= articleDOM+" ."+scrollPageClass,
		articleHeight 	= $article.height(),
		pageDepth		= (isMobile) ? 600 : 1000,
		totalPages		= Math.floor(articleHeight/pageDepth);



		$article.css("position","relative");

		//Adds a set of abosolutely positioned divs over the article.  Each div represents a page.
		for (var i = 1; i <= totalPages; i++) {
			$article.find(".scroll-pagination").append("<div class=\"scroll-page\" data-page=\""+i+"\"></div>");
		}
		$(scrollPageDOM).height(pageDepth);



		//Create a waypoint for each article page
		var scrollPages 			= document.getElementById(articleID).getElementsByClassName(scrollPageClass),
			changeArticlePage 		= function(pageNumber){

				var currentPage		= commonJS.getURLParam("page"),
					trackArticle	= __gh__webApp.utilities.tracker.trackArticle;

				if (currentPage == pageNumber || !currentPage && pageNumber == 1){return;}

				var	historyApiURL = commonJS.updateURLParams({
						"url":articleObject.link,
						"params":{"page":pageNumber}
					}),
					pageData = {
		    			"page" : pageNumber,
		    			"articleDOM": articleDOM,
		    			"_index": History.getCurrentIndex()
		    		},
		    		pageTitle = commonJS.getPageTitleWithPageNumber({
			    		"title":articleObject.title,
			    		"pageNumber":pageNumber}
			    	);
					History.replaceState(pageData, pageTitle, historyApiURL);

				trackArticle.pagination({
					"articleObject":articleObject,
					"pageNumber":pageNumber
				});
			};



			for (var i = 0; i < scrollPages.length; i++) {
			  new Waypoint({
			    element: scrollPages[i],
			    handler: function() {
					var	pageNumber 		= this.element.dataset.page;
					changeArticlePage(pageNumber);
			    }
			  });
			}
};









/*
|--------------------------------------------------------------------------
| Article: Sticky Meta
|--------------------------------------------------------------------------
*/

/**
 * Sticky Meta info on scroll
 *
 */
 __gh__webApp.articlePage.stickyMeta = {

 	"init": function(articleDOM){
 		this.bindEvents(articleDOM);
 	},

 	"bindEvents": function(articleDOM) {

 		if($(articleDOM).hasClass('article-v2') === true) { return }

 		var $stickyEl = $(articleDOM + ' .article-meta .inner'),
 			$nonStickyEl = $(articleDOM + ' .article-meta > *:not(.inner)'),
 			$stopEl   = $stickyEl.parent().parent().find('.article-body'),
 			stickyTop, stopPoint, windowTop;

 		if($stickyEl.length) {
 			$(window).on('load', function() {
 				stickyTop = $stickyEl.offset().top;
 			});
 			$(window).on('scroll resize', function() {
 				if(window.innerWidth >= 768) {
 					var leftRailSize = $nonStickyEl.height() + $stickyEl.height();
 					var articleSize = $stopEl.height();
 					if(leftRailSize > articleSize) {
 						$stopEl.css('min-height',leftRailSize);
 					}
 					$stickyEl.parent().css({
 						'height': $stopEl.height(),
 						'position': 'relative'
 					});

 					windowTop = $(window).scrollTop() + $('#toprail').height() + 14;
 					stickyTop = $stickyEl.parent().offset().top;
 					stickyBottom = stickyTop + $stickyEl.height();
 					stopPoint = Math.round($stopEl.height() + $stopEl.offset().top - $stickyEl.height());


 					if (stickyTop < windowTop && stopPoint > windowTop && stickyBottom < stopPoint) {
 						$stickyEl.css({
 							'position': 'fixed',
 							'top': '14px',
 							'bottom': 'auto',
 							'width': $stickyEl.parent().width(),
 							'background-color': '#fff',
 							'z-index': 1
 						});
 						$nonStickyEl.css({'margin-top': $stickyEl.height()});
 					} else if(stopPoint <= windowTop && stickyBottom < stopPoint) {
 						$stickyEl.css({
 							'position': 'absolute',
 							'top': 'auto',
 							'bottom': 0
 						});
 					} else {
 						$stickyEl.css({
 							'position': 'inherit',
 							'width': 'auto',
 							'top': 0
 						});
 						$nonStickyEl.css({'margin-top': 0});
 					}
 				} else {
 					$stickyEl.parent().css({
 						'height': 'auto',
 						'position': 'inherit'
 					});
 					$stickyEl.css({
 						'position': 'inherit',
 						'width': 'auto'
 					});
 					$stopEl.css('min-height', 0);
 					$nonStickyEl.css({'margin-top': 0});
 				}
 			});
 		}
 	}
 };









/*
|--------------------------------------------------------------------------
| Article: Article storyStrip
|--------------------------------------------------------------------------
*/

/**
 * Bar with more articles in a slider
 */
 __gh__webApp.articlePage.storyStrip = {

 	"init": function(articleDOM) {
 		this.bindEvents(articleDOM);
 	},

 	"inject": function(articleDOM)  {
		var device			 	= __gh__webApp.device,
			slider 				= __gh__webApp.utilities.slider,
			$storyStrip       	= $('#article-storyStrip'),
			$header           	= $('#header-main'),
			$article 			= $(articleDOM),
			storyStripHeight 	= $storyStrip.find('.gh-slider-storyStrip').outerHeight(),
			currentLocation  	= $storyStrip.parent(),
			newCSS           	= {},
			isPhone				= device.isPhone(),
			appendPrependTo		= "appendTo",
			$newLocation,
			$newParent;
		
		// mobile - attach to ad
		if(isPhone) {
			$newParent 					= $article.find('.inner .article-body > .inner');
			$newLocation 				= $newParent.find('.ad-container').eq(1);
			appendPrependTo				= ($newLocation) ? "prependTo" : appendPrependTo;
			$newLocation				= ($newLocation) ? $newLocation : $article.find(".article-body"),
			newCSS.storyStripPosition 	= 'relative';
			newCSS.headerMargin 		= 0;
			$storyStrip.css('top', 0);
		}
		// desktop - attach to header, make sticky
		else {
			$newParent 					= $header;
			$newLocation 				= $header;
			newCSS.storyStripPosition 	= 'fixed';
			newCSS.headerMargin 		= storyStripHeight;
		}

		// move if necessary
		if($newLocation.attr('class') != currentLocation.attr('class')) {
			$storyStrip.remove();
			$storyStrip.css('position', newCSS.storyStripPosition);
			$header.css('margin-bottom', newCSS.headerMargin);
			$storyStrip[appendPrependTo]($newLocation);
			slider.reInit("#article-storyStrip .gh-slider"); // reinitialize slider
		}
	},

 	"sticky": function(articleDOM, oldScroll) {
 		var $header            	= $('#header-main'),
			$storyStrip        	= $('#article-storyStrip'),
			$stopPoint        	= $('#article .article-body'),
			navHeight         	= $('#toprail').outerHeight(),
			storyStripHeight  	= $storyStrip.outerHeight(),
			stickyTop         	= $header.outerHeight(),
			winHeight         	= $(window).height(),
			docHeight         	= $(document).height(),
			newScroll         	= $(window).scrollTop(),
			scrollAmount      	= oldScroll - newScroll,
			storyStripLocation  = parseInt($storyStrip.css('top')) + scrollAmount,
			stopPointLocation   = $stopPoint.offset().top + $stopPoint.outerHeight(),
			newLocation       	= 0,
			isScrollDown		= (scrollAmount < 0),
			isScrollUp			= (scrollAmount > 0),
			isPageTop			= (newScroll + navHeight <= stickyTop),
			isNotPageBottom 	= (winHeight + scrollAmount < docHeight - storyStripHeight),
			isAfterStopPoint    = (newScroll > stopPointLocation);


 		if(isPageTop) {
 			newLocation = stickyTop - newScroll;
 			//console.info('hit top area of page');
 		}

 		else if(isScrollDown){
 			// no more fancy hiding while scrolling down... saving for later use
 			/*if (isNotPageBottom) {
				newLocation = (Math.abs(storyStripLocation) > storyStripHeight) ? -(storyStripHeight) : storyStripLocation;
				console.info('going down');
 			}
 			else {
				storyStripLocation 	= newScroll + winHeight - docHeight;
				newLocation 		= (storyStripLocation < 0) ? storyStripLocation : navHeight;
				console.info('hit bottom of page');
			}*/

 			if (isNotPageBottom && !isAfterStopPoint) {
				newLocation = navHeight;
 			} else {
 				newLocation = (Math.abs(storyStripLocation) > storyStripHeight) ? -(storyStripHeight) : storyStripLocation;
 			}
 		}
 		
 		else if(isScrollUp) {

 			if (storyStripLocation < stickyTop && !isAfterStopPoint) {
	 			// stick to bottom of header
				newLocation = (storyStripLocation > navHeight) ? navHeight : storyStripLocation;
				// console.info('storyStripLocation < stickyTop');
			}

			else if (isAfterStopPoint) {
				newLocation = -(storyStripHeight);
			}

 			else { 
	 			// stick to sticky navigation
				newLocation = (storyStripLocation > stickyTop) ? navHeight : storyStripLocation;
	 			// console.info('going up');
	 		}
		}

		$storyStrip.css('top', newLocation);

 		return newScroll;
 	},

 	"bindEvents": function(articleDOM) {
 		var thisObject 			= __gh__webApp.articlePage.storyStrip,
 			device 				= __gh__webApp.device,
 			header 				= $('#header-main'),
 			oldScroll 			= 0;
 		
		thisObject.inject(articleDOM);
		
		$(window).on('resize', function() {
			thisObject.inject(articleDOM);
		});
 		
 		$(window).on('scroll', function() {
 			// mobile is not sticky... do nothing (placeholder because this may change in the future)
	 		if(device.isPhone()) { return; }

	 		// on desktop, stick it and record the position
	 		oldScroll = thisObject.sticky(articleDOM, oldScroll);
 		});
 	}
 };





/*
|--------------------------------------------------------------------------
| Article: Show more/less related links
|--------------------------------------------------------------------------
*/

__gh__webApp.articlePage.relatedLinksHandler = {
	"init":function(){
		this.bindEvents();
	},
	"handler":{
		relLinkLimit: 3,
		relLiksContainer: '.related-stories',
		relLiksArray: '.related-stories article',
		showMoreLessHTML: '<a href="#" class="expand">Show more <i class="fa fa-caret-down"></i></a>',
		expandBtn: '.related-stories .expand',
		collapseBtn: '.related-stories .collapse',
		showMoreHTML: 'Show more <i class="fa fa-caret-down"></i>',
		showLessHTML: 'Show less <i class="fa fa-caret-up"></i>'
	},
	"expand":function(e){
		var Handler 		= this.handler,
			$this 			= $(Handler.expandBtn),
			$linksArray 	= $(Handler.relLiksArray);

		$this.html(Handler.showLessHTML);
		$this.removeClass('expand');
		$this.addClass('collapse');

		$linksArray.each(function(){$(this).fadeIn();});
	},
	"collapse":function(e){
		var Handler 		= this.handler,
			$this 			= $(Handler.expandBtn),
			$linksArray 	= $(Handler.relLiksArray);

		$this.html(Handler.showMoreHTML);
		$this.addClass('expand');
		$this.removeClass('collapse');

		$linksArray.each(function(i){if(i > (Handler.relLinkLimit-1)){$(this).fadeOut('fast');}});
	},
	"bindEvents":function(){
		var HandlerObject 			= this,
			Handler		 			= HandlerObject.handler,
			$linksArray				= $(Handler.relLiksArray),
			$linksContainer			= $(Handler.relLiksContainer);

		if($linksArray.length > Handler.relLinkLimit){
			$(Handler.showMoreLessHTML).appendTo($linksContainer);
			$linksArray.each(function(i){
				if(i > (Handler.relLinkLimit-1)){
					$(this).hide();
				}
			});
		}
		$(document).on('click', Handler.expandBtn, function(index,element){
			HandlerObject.expand(index);
			index.preventDefault();
		});
		$(document).on('click', Handler.collapseBtn, function(index,element){
			HandlerObject.collapse(index);
			index.preventDefault();
		});
	}
};







/*
|--------------------------------------------------------------------------
| Article: Article URL Handler
|--------------------------------------------------------------------------
*/

/**
 * Update the article url on scroll
 * When exiting a read more article, change back to the main article's url
 * When entering a read more article, change back to that articles url
 */
__gh__webApp.articlePage.articleURLHandler = {
	"refreshScrollListeners": function() {
		Waypoint.refreshAll();
	},
	"addScrollListeners": function (articleDOM,articleObject) {
		
		//Get the main article object, different index within buckets depending on whether it's a blog page or not.
		function getMainArticleObject(){
			var buckets	= __gh__coreData.pageData.buckets;

			for (var i = 0; i < buckets.length; i++) {
				if (buckets[i].view.staticName != "article"){ continue; }
				return __gh__coreData.pageData.buckets[i].items.main[0];
			}
		}
		
		var mainArticleObject = getMainArticleObject();
		
		// Update location bar url
		function updateToMainArticleURL() {
			History.replaceState({}, mainArticleObject.title, mainArticleObject.link);
		}
		function updateToArticleURL() {
			History.replaceState({}, articleObject.title, articleObject.link);
		}
		
		//Top of the article
		new Waypoint({
		  element: $(articleDOM)[0],
		  handler: function(direction) {
			if (direction == "up"){
				updateToMainArticleURL();
				return;	
			}
		  	updateToArticleURL();
		  }
		});
		
		//Bottom of the article
		new Waypoint({
		  element:  $(articleDOM)[0],
		  handler: function(direction) {
		  	if (direction == "down"){
				updateToMainArticleURL();
			  	return;
		  	}
		    updateToArticleURL();
		  },
		  offset:'bottom-in-view'
		});
		
	}
};



/*
|--------------------------------------------------------------------------
| Article: Article downloader
|--------------------------------------------------------------------------
*/

/**
 * Add download button to article meta area
 * if enable:articleDownloads is set to true in LocalData.ini
 */
__gh__webApp.articlePage.downloader = {

	"images": [],
	"otherFormats": '',
	"textContent": '',
	"zip": new JSZip(),

	"isEnabled": function() {
		return (__gh__coreData.siteData.articleDownloads || false);
	},

	"prepFile": function(articleDOM, articleObject) {
		var thisObject = __gh__webApp.articlePage.downloader;
		if(thisObject.isEnabled() === false) { return; }

		var article    		= articleObject,
			hasBody	   		= (article.body.length),
			cleanText  		= (hasBody) ? article.body[0].replace(/<(\/p|br)\s?\/?>/g, "\n\n").replace(/<p>/g, '') : "",
			imgCount   		= 0,
			imgTextContent 	= "",
			img;

		article.body = cleanText || "error processing article body";
		if(article.author === undefined) {
			article.author = '';
			for(i = 0; i < article.byline.length; i++) {
				if(i > 0) article.author += "\nand ";
				article.author += article.byline[i].name;
			}
		}

		thisObject.zip.filename = article.id + '-' 
			+ article.title.slice(0, 200)
				.replace(/[^a-z0-9]/gi, '_')
				.replace(/_{2,}/g, '_')
				.toLowerCase();

		$.each($(articleDOM).find('.related-facts a'), function() {
			var link = $(this);
			if(link.attr('href').indexOf('mailto') == -1) {
				thisObject.otherFormats += link.attr('title') ? link.attr('title') : link.text();
				thisObject.otherFormats += ': '+ link.attr('href') +"\n";
			}
		});
		

		$.each(article.relatedContent.items, function(_, rel) {
			
			if(rel.type.toLowerCase().indexOf('images') !== -1) {
				
				$.each(rel.items, function(_, item) {
					var imgExt 			= item.link.slice(item.link.lastIndexOf('.')),
						imgName 		= ("00" + imgCount).slice(-3) + imgExt;
						imgTextContent 	+= (item.caption.length) ? imgName + ":\n" + item.caption + "\n\n" : "";

					if(imgCount === 0) img = thisObject.zip.folder("images");
					img.file(
						imgName,
						thisObject.urlGrabber(item.link),
						{ base64: true }
					);

					thisObject.images.push(item);
					imgCount++;
				});
			}
		});
		imgTextContent = (imgTextContent != "") ? "\n\nStory Image Captions:\n" + imgTextContent : "";

		thisObject.textContent = 
			article.title +"\n"
			+ ((article.author === '') ? 'Author not specified' : article.author) +"\n"
			+ article.pubDateFormat['yyyy-mm-dd hh:mm:ss'] + "\n"
			+ ((thisObject.otherFormats === '') ? '' : thisObject.otherFormats) + "\n\n"
			+ article.body
			+ imgTextContent;
	
		thisObject.zip.file(
			thisObject.zip.filename + ".txt",
			thisObject.textContent
		);



		$(articleDOM).find('.article-meta .inner')
			.prepend('<a href="" class="btn btn-default" data-gh-download-article>Download article</a><br><br>');

		this.bindEvents();
	},

	"urlGrabber": function(url) {
		return new Promise(function(resolve, reject) {
			JSZipUtils.getBinaryContent(url, function (err, data) {
				if(err) { reject(err); }
				else { resolve(data); }
			});
		});
	},

	"download": function(options) {
		var thisObject = __gh__webApp.articlePage.downloader;

		if(options.type == "blob") {
			thisObject.zip.generateAsync(options).then(function(content) {
				saveAs(content, thisObject.zip.filename);
			}, function(err) {
				console.error('Download failed');
			});
		} else {
			thisObject.downloadModal();
		}
	},

	"downloadModal": function() {
		var thisObject = __gh__webApp.articlePage.downloader,
			modal = __gh__webApp.utilities.modal;

		//
		// TODO: refactor this to use a handlebars template
		//       instead of building here... if possible
		//       
		// apologies to anyone who has to see the following horror
		//
		var $outer, $inner,
			$contentHead, $contentArea, $contentButton,
			$images, $imagesHead, $figure, $image;

		$outer = $('<div/>', {
			class: 'modal-dialog',
			id: 'article-download-modal'
		});

		$inner = $('<div/>',{ class: 'inner' }).appendTo($outer);

		$contentHead = $('<h2/>', {
			class: 'headline',
			html: 'Story Content<small>Click the "Copy to Clipboard" button below to copy the full article to your clipboard</small>'
		}).appendTo($inner);

		$contentArea = $('<textarea/>', {
			id: 'article-download-body',
			text: thisObject.textContent
		}).appendTo($inner);

		$contentButton = $('<button/>', {
			class: 'btn btn-success',
			id: 'article-download-copy',
			text: 'Copy to clipboard'
		}).appendTo($inner);

		$images = $('<div/>',{ id: 'article-download-images' }).appendTo($inner);

		$imagesHead = $('<h2/>', {
			class: 'headline',
			html: 'Story Images<small>Click on an image below to save it to your computer</small>'
		}).appendTo($images);

		$.each(thisObject.images, function(_, img) {
			$figure = $('<figure/>', { class: 'thumb' }).appendTo($images);
			$image = $('<div/>', { class: 'image', "data-src": img.link }).appendTo($figure);
		});

		modal.openModal({"url": 'data:text/html;charset=UTF-8,'+ $outer.prop('outerHTML') });
	},

	"downloadImage": function(image) {
		var $image    = $(image),
			imageURL  = $image.data('src').split('?')[0],
			$magic    = $('<a>',{ href: imageURL, download: '', target: '_blank' });

		$magic.appendTo('body');
		$magic[0].click();
		$magic.remove();
	},

	"copyArticle": function(article) {
		var $article     = $(article),
			$button      = $('#article-download-copy'),
			$buttonOrig  = $button.html();

		$article.select();
		document.execCommand('copy');

		$button.html('<i class="fa fa-check"></i> Copied');
		setTimeout(function(){ $button.html($buttonOrig) }, 3000);
	},

	"bindEvents": function() {
		var thisObject    = __gh__webApp.articlePage.downloader,
			isSafari      = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/),
			supportsBlob  = $.isFunction(window.Blob),
			options       = (isSafari || !supportsBlob) ? {type:"base64"} : {type:"blob"};

		if(options.type == 'blob') {
			var $modalLink = $('<div/>', {
				html: 'or <a href="#">pick and choose assets</a> to save',
				click: function(e) {
					thisObject.downloadModal();
					e.preventDefault();
				}
			}).insertAfter('a[data-gh-download-article]');
		}

		$(document).on('click', 'a[data-gh-download-article]', function(e) {
			thisObject.download(options);
			e.preventDefault();
		});

		$(document).on('click', '#article-download-copy', function() {
			thisObject.copyArticle('#article-download-body');
		});

		$(document).on('click', '#article-download-images .image', function() {
			thisObject.downloadImage(this);
		});
	}
};




/*
|--------------------------------------------------------------------------
| Article Ext Login Page: Init
|--------------------------------------------------------------------------
*/
__gh__webApp.articleExtLoginPage.init = function(){
	var paywall		= __gh__webApp.paywall;
	
	$(document).ready(function() {
		
		paywall.readSession({
			"callback": function(data){
				paywall.toggleLoginLogoutText(data);
				paywall.doWallOnTimer(data);
			}
		});
		
		//disable right click
		$(document).bind("contextmenu",function(e){ 
			return false; 
		});
	});
	
};


// Initialize Article Page
// __gh__webApp.articlePage.init();
